import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import DateFilter from "components/Pickers/DateRange";
import { memo, useCallback, useState } from "react";
import { createSearchParams, useNavigate } from "react-router-dom";
import { FILTER_TEXT_COLOR, PRIMARY } from "styles/colors";
import useQueryParams from "utils/hooks/useQueryParams";

function Filters() {
  const params = useQueryParams();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const toggle = useCallback(() => {
    setOpen(!open);
    if (open) {
      navigate(`/users/sellers`);
    }
  }, [navigate, open]);

  const handleChange = useCallback(
    (range) => {
      let _params = params;
      _params.from = range.startDate.toDateString();
      _params.to = range.endDate.toDateString();
      navigate({
        search: createSearchParams(_params).toString(),
      });
    },
    [navigate, params]
  );

  return (
    <Box display="flex" gap={2}>
      {!open ? (
        <Button
          variant="text"
          onClick={toggle}
          className="Filter-toggle-btn"
          sx={{
            borderBottom: "2px solid",
            borderColor: PRIMARY,
            borderRadius: 0,
            textTransform: "none",
          }}
        >
          Filter
        </Button>
      ) : (
        <DateFilter onChange={handleChange} />
      )}
      {open && (
        <Button
          onClick={toggle}
          variant="text"
          className="Filter-toggle-btn"
          sx={{
            borderBottom: "2px solid #707070",
            borderRadius: 0,
            color: FILTER_TEXT_COLOR,
            textTransform: "none",
          }}
        >
          Clear All
        </Button>
      )}
    </Box>
  );
}

export default memo(Filters);
